import script from "./GlobalVariable.vue?vue&type=script&lang=js"
export * from "./GlobalVariable.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__